import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { http, formatApiError } from "@/lib/api";
import { MemoryBook } from "@/components/live/MemoryBook";

export default function MemoryBookPage() {
  const { classId, kidId } = useParams();
  const [m, setM] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    http.get(kidId ? `/family/children/${kidId}/memory/${classId}` : `/live/classes/${classId}/memory`).then((r) => setM(r.data)).catch((e) => setErr(formatApiError(e)));
  }, [classId, kidId]);
  const back = kidId ? "/parent" : "/live";
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-10 pb-24" data-testid="memory-page">
      <Link to={back} className="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-[#2C4A3E] mb-6" data-testid="memory-back"><ArrowLeft className="w-4 h-4" /> Back</Link>
      {err ? <p className="text-stone-600" data-testid="memory-error">{err}</p> : m ? <MemoryBook m={m} /> : <p className="text-stone-500" data-testid="memory-loading">Making your keepsake page…</p>}
    </div>
  );
}
